
import { MapMods, ManhuntMapPoi } from "@/models/MapPois/ManHunt/ManhuntMapPoi";
import { cloneDeep, orderBy } from "lodash";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
class PoiMapModifiersTriggerTable extends Vue {
  @Prop({ default: true }) readonly content!: MapMods;
  @Prop({ default: "" }) readonly currentItem!: string;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  contentClone = {} as MapMods;
  buttonOption: string[] = [];
  busy = false;
  fields = [
    {
      key: "targets",
      label: "POI Targets",
      sortable: true,
    },
    {
      key: "status",
      label: "New Status",
      sortable: true,
    },
  ];
  created(): void {
    this.contentClone = cloneDeep(this.content);
  }

  get getMapPoiData(): ManhuntMapPoi[] {
    return orderBy(
      this.$store.state.mapPoiStore.mapPoi,
      (o: ManhuntMapPoi) => o.title.en.toLowerCase(),
      "asc"
    ).filter((x: ManhuntMapPoi) => x.title.en !== "START_ZONE");
  }

  getSelectedOption(key: string): string {
    if (this.content.trigger_list !== undefined) {
      if (this.content.trigger_list[key] !== undefined) {
        if (this.content.trigger_list[key]) {
          return "enabled";
        } else {
          return "disabled";
        }
      } else {
        return "ignored";
      }
    } else {
      return "ignored";
    }
  }

  onValueChanged(row: any, type: string): void {
    try {
      if (type === "enabled" || type === "disabled") {
        var isEnabled = type === "enabled" ? true : false;
        if (this.contentClone.trigger_list !== undefined) {
          this.contentClone.trigger_list![row.item.key] = isEnabled;
        } else {
          this.contentClone.trigger_list = {
            [row.item.key]: isEnabled,
          };
        }
      } else {
        if (this.contentClone.trigger_list![row.item.key] !== undefined) {
          delete this.contentClone.trigger_list![row.item.key];
        }
      }
      this.$emit("updateTempObject", this.contentClone);
    } catch (error) {
      console.log(error);
    }
  }
}

export default PoiMapModifiersTriggerTable;
